import React from "react";
import Header from "./Header";
import { Outlet, ScrollRestoration, useSearchParams } from "react-router-dom";
import Footer from "./Footer";

const Layout = () => {
  const [searchParams] = useSearchParams();
  const hideHeader = searchParams.get("hide-header");
  const hideFooter = searchParams.get("hide-footer");

  return (
    <>
      {!hideHeader && <Header />}
      <div className="container">
        <ScrollRestoration />
        <Outlet />
      </div>
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
